"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.2 5.4a1.8 1.8 0 0 0-1.8 1.8v4.656a1.4 1.4 0 0 0 1.402 1.401h.345c.892 0 1.616.723 1.616 1.616 0 .198.245.29.376.142l.907-1.033c.405-.46.989-.725 1.602-.725H13.8a1.8 1.8 0 0 0 1.8-1.8V10.33a.7.7 0 1 1 1.4 0v1.128a3.2 3.2 0 0 1-3.2 3.2h-3.152a.731.731 0 0 0-.55.25l-.907 1.032c-.984 1.119-2.829.423-2.829-1.066a.215.215 0 0 0-.215-.216h-.345A2.8 2.8 0 0 1 3 11.856V7.2A3.2 3.2 0 0 1 6.2 4h3.3a.7.7 0 0 1 0 1.4z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.5 2.3a.7.7 0 0 1 .7.7v1.8H17a.7.7 0 0 1 0 1.4h-1.8V8a.7.7 0 1 1-1.4 0V6.2H12a.7.7 0 1 1 0-1.4h1.8V3a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AddCommentIcon20.js.map